"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.post.saved': 'Publicación guardada',
    'socialMediaPlan.post.saveFailed': 'Error al guardar',
    'socialMediaPlan.post.publish': 'Publicar ahora',
    'socialMediaPlan.post.publishedOn': 'Publicado en',
    'socialMediaPlan.post.publishFailed': 'Error al publicar en',
    'socialMediaPlan.post.publishError': 'Error al publicar. Inténtalo de nuevo.',
    'socialMediaPlan.post.duplicated': 'Publicación duplicada',
    'socialMediaPlan.post.duplicateFailed': 'Error al duplicar',
    'socialMediaPlan.post.deleted': 'Publicación eliminada',
    'socialMediaPlan.post.deleteFailed': 'Error al eliminar',
    'socialMediaPlan.post.deleteConfirm': '¿Eliminar esta publicación?',
};
